import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DesignerContextType } from '../../types/designer-context-type';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { SxMainContainer } from '../main/main-container.component';
import { SxInternalStateDesignerService } from '../../services/internal-state-designer-service';

@Component({
  selector: 'sx-attribute-modal',
  templateUrl: './attribute-modal.component.html',
})
export class SxAttributeModalComponent {
  // Designer Context
  @Input()
  designerContext: DesignerContextType;
  // PrincipalDesignerReference
  @Input()
  mainContainer: SxMainContainer;
  // Input Search
  @Input()
  searchAtt: string;

  @Output()
  filterAttr: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  attFiltered: any[];

  // Selected element Modal
  itemSelected: any;
  // Selected element in Modal
  elementSelected: any;
  // instancia del modal
  instance: any;

  constructor(
    private ngxSmartModalService: NgxSmartModalService,
    public internalState: SxInternalStateDesignerService
  ) {}

  setControlModal(event: any, item: any) {
    this.instance = this.ngxSmartModalService.getModalData('attributesModal');
    this.itemSelected = item;
    this.elementSelected = event.srcElement;
    while (event.target !== undefined && event.target.id === '') {
      event = event.srcElement.parentElement;
      this.elementSelected = event;
    }
  }

  addNewElement() {
    this.mainContainer.addElementWithoutDragula(
      this.elementSelected,
      this.instance
    );
    this.ngxSmartModalService.resetModalData('attributesModal');
    this.ngxSmartModalService.getModal('attributesModal').close();
  }

  isActive(item: any) {
    return this.itemSelected === item;
  }

  setFilter(): void {
    this.internalState.setCurrentFilterAttr(this.searchAtt);
    this.filterAttr.emit();
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/modals/attribute-modal.component.ts